import { RouteObject } from "../../interfaces/navigation";
import React from "react";
import MyAccount from "../../containers/Profile/MyAccount/EntryPointContainer";
import Dashboard from "../../containers/Profile/Dashboard/EntryPointContainer";
import Sellers from "../../containers/Profile/Sellers/EntryPointContainer";
import Favorites from "../../containers/Profile/Favorites/EntryPointContainer";
import { myPublicationsRoutes } from "./MyPublications/routes";
import { myPublicationsBrandRoutes } from "./BrandMyPublication/routes";
import { documentationRoutes } from "./Documentation/routes";
import Schedules from "../../containers/Profile/Schedules/EntryPointContainer";
import Branches from "../../containers/Profile/Branches/EntryPointContainer";
import Concessionaire from "../../containers/Profile/Dealerships/EntryPointContainer";
import { leadsRoutes } from "./Leads/routes";
import { myOffersRoutes } from "./MyOffers/routes";

const ProfileContainer = React.lazy(() => import("../../containers/Profile/ProfileContainer"));

export const profileSubRoutes: RouteObject[] = [
    {
        title: "Mi Cuenta",
        path: "my_account",
        component: <MyAccount/>,
        protected: true
    },
    {
        title: "Dashboard",
        path: "dashboard",
        component: <Dashboard/>,
        protected: true
    },
    ...myPublicationsRoutes,
    ...myPublicationsBrandRoutes,
    ...myOffersRoutes,
    {
        title: "Favoritos",
        path: "favorites",
        component: <Favorites/>,
        protected: true
    },
    {
        title: "Agendamientos",
        path: "my_schedules",
        component: <Schedules/>,
        protected: true
    },
    ...leadsRoutes,
    {
        title: "Vendedores",
        path: "sellers",
        component: <Sellers/>,
        protected: true
    },
    {
        title: "Sucursales",
        path: "branches",
        component: <Branches/>,
        protected: true
    },
    {
        title: "Concesionarios",
        path: "dealerships",
        component: <Concessionaire/>,
        protected: true
    },
    ...documentationRoutes
];

export const profileRoutes: RouteObject[] = [
    {
        title: "Profile",
        path: "/profile",
        component: <ProfileContainer/>,
        protected: true,
        subRoutes: profileSubRoutes
    }
];